import axios from "axios";
import axiosInstance from "@/lib/axios";
import type { PersonResponse, ApiErrorResponse } from "@/types/person";

const PERSONS_URL = "/persons";

export const getPersonById = async (
  uuid: string,
  params?: { page?: number; limit?: number }
): Promise<PersonResponse> => {
  try {
    const { data } = await axiosInstance.get<PersonResponse>(
      `${PERSONS_URL}/${uuid}`,
      { params, withCredentials: true }
    );
    return data;
  } catch (err: unknown) {
    if (axios.isAxiosError?.(err)) {
      throw err.response?.data as ApiErrorResponse;
    }
    throw err;
  }
};
